/**
 * Shared node operations for Visual Editor and Visual Story Planner
 */

/**
 * Reparent a node to a new parent, updating edges and body links
 * @param {Object} graph - Current graph state {nodes, edges}
 * @param {string} nodeToMove - ID of node being moved
 * @param {string} newParentId - ID of new parent node
 * @returns {Object} Updated graph state
 */
export const reparentNode = (graph, nodeToMove, newParentId) => {
  // Find old parent(s) by checking edges
  const oldParentIds = (graph.edges || [])
    .filter(e => (e.target || e.to) === nodeToMove)
    .map(e => e.source || e.from);
  
  // Remove edges TO this node
  const filteredEdges = (graph.edges || []).filter(e => 
    (e.target || e.to) !== nodeToMove
  );
  
  // Add new edge
  const newEdge = { source: newParentId, target: nodeToMove, from: newParentId, to: nodeToMove };
  
  // Update nodes: remove link from old parents, add to new parent
  const updatedNodes = graph.nodes.map(n => {
    // Remove link from old parent's body
    if (oldParentIds.includes(n.id)) {
      let newBody = n.body || '';
      newBody = newBody.replace(new RegExp(`\\[\\[${nodeToMove}\\]\\]\\n?`, 'g'), '');
      newBody = newBody.replace(new RegExp(`\\[\\[[^\\]]*\\|${nodeToMove}\\]\\]\\n?`, 'g'), '');
      newBody = newBody.replace(new RegExp(`\\[\\[[^\\]]*->${nodeToMove}\\]\\]\\n?`, 'g'), '');
      return { ...n, body: newBody.trim() };
    }
    // Add link to new parent's body
    if (n.id === newParentId && !n.body?.includes(`[[${nodeToMove}]]`)) {
      return { ...n, body: (n.body || '') + `\n[[${nodeToMove}]]` };
    }
    return n;
  });
  
  return { ...graph, nodes: updatedNodes, edges: [...filteredEdges, newEdge] };
};
